import { Network, Tag } from "lucide-react"
import type { ScopeNode } from "@/components/ChannelMenu"
import ScopeBreadcrumb from "../../Revenue/components/ScopeBreadcrumb"

interface Props {
  scopeTree: ScopeNode[]
  scopeId: string
  marketId: string
  hrefForScope: (slug: string) => string
  categoryTree: ScopeNode[]
  categoryId: string | null
  hrefForCategory: (slug: string) => string
}

// The id of the "All categories" top of the category tree (CategoryTree::ALL_ID).
const ALL_CATEGORIES = "all"

/**
 * The drilled-in scope and category, side by side on one line (wrapping on
 * narrow screens), each with an [x] that removes that filter. A path shows
 * only once that picker is below its top; nothing shows when neither is.
 */
export default function ActualsPaths({ scopeTree, scopeId, marketId, hrefForScope, categoryTree, categoryId, hrefForCategory }: Props) {
  if (scopeId === marketId && !categoryId) return null

  return (
    <div className="flex flex-wrap items-center gap-x-4 gap-y-1.5 border-b px-4 py-3 [&>nav+nav]:border-l [&>nav+nav]:pl-4">
      <ScopeBreadcrumb
        scopeTree={scopeTree}
        scopeId={scopeId}
        marketId={marketId}
        hrefForScope={hrefForScope}
        label="Scope"
        icon={Network}
        clearable
        className=""
      />
      <ScopeBreadcrumb
        scopeTree={categoryTree}
        scopeId={categoryId ?? ALL_CATEGORIES}
        marketId={ALL_CATEGORIES}
        hrefForScope={hrefForCategory}
        label="Category"
        icon={Tag}
        clearable
        className=""
      />
    </div>
  )
}
